module.exports = __webpack_public_path__ + "static/media/gc-dionisio.b1573ae3.png";